module.exports = __webpack_public_path__ + "img/box-arrow-right.1e311d44.svg";